import { useCallback, useContext } from 'react'

import { LocaleContext } from './locale-provider'
import strings from './strings'
// import { StringsType } from './types'

const useTranslation = () => {
    const locale = useContext(LocaleContext)

    return useCallback(
        (key) =>
            strings[locale][key],
        [locale],
    )
}

export default useTranslation
